<template lang="pug">
  .store-feed-select
    .panel-page-white.body-1
      .panel-white.mx-auto
        PageHeader Live Store Feed Selection
        p Enter up to 5 zip codes and select up to 10 stores to view transactions as they occur on selected stores.
        ZipSearch.mb-3(
          label-number="1"
          v-model="selectedStores1"
          :zipcode.sync="searchZip1"
          :searchStores="searchStores1"
          :count="selectedCount"
        )
        ZipSearch.mb-3(
          label-number="2"
          v-model="selectedStores2"
          :zipcode.sync="searchZip2"
          :searchStores="searchStores2"
          :count="selectedCount"
        )
        ZipSearch.mb-3(
          label-number="3"
          v-model="selectedStores3"
          :zipcode.sync="searchZip3"
          :searchStores="searchStores3"
          :count="selectedCount"
        )
        ZipSearch.mb-3(
          label-number="4"
          v-model="selectedStores4"
          :zipcode.sync="searchZip4"
          :searchStores="searchStores4"
          :count="selectedCount"
        )
        ZipSearch.mb-3(
          label-number="5"
          v-model="selectedStores5"
          :zipcode.sync="searchZip5"
          :searchStores="searchStores5"
          :count="selectedCount"
        )

        button.btn.btn-primary(@click.prevent="viewStoreFeed") View Store Feed
</template>

<script>
import { loadForm, saveItem, formItem } from '@/lib/formstore'
import PageHeader from '@/components/PageHeader'
import ZipSearch from '@/components/ZipSearch'
import axios from '@/lib/axios'

function searchZip(zip) {
  return axios().get('/api/store_feed/pharmacies', { params: { zip } })
}

function watcherFunc(num) {
  const [selStores, searchStores] = [
    `selectedStores${num}`,
    `searchStores${num}`,
  ]
  return function(val, oldVal) {
    if (val.length !== 5 && oldVal.length === 5) {
      this[selStores] = []
      this[searchStores] = []
      return
    } else if (val.length !== 5) {
      return
    }
    searchZip(val)
      .then(resp => {
        let stores = resp.data.filter(st => !st.inactive)
        this[searchStores] = stores
      })
      .catch(err => globalError(err))
  }
}

export default {
  name: 'StoreFeedSelect',
  data: function() {
    return {
      selectedStores1: [],
      searchZip1: '',
      searchStores1: [],
      selectedStores2: [],
      searchZip2: '',
      searchStores2: [],
      selectedStores3: [],
      searchZip3: '',
      searchStores3: [],
      selectedStores4: [],
      searchZip4: '',
      searchStores4: [],
      selectedStores5: [],
      searchZip5: '',
      searchStores5: [],
    }
  },
  methods: {
    viewStoreFeed: function() {
      this.$store.commit('watchStores', [...this.selectedStores])
      axios()
        .post('/api/store_feed/record')
        .then(() => this.$router.push({ name: 'store_feed' }))
    },
  },
  computed: {
    selectedStores() {
      return new Set([
        ...this.selectedStores1,
        ...this.selectedStores2,
        ...this.selectedStores3,
        ...this.selectedStores4,
        ...this.selectedStores5,
      ])
    },
    selectedCount() {
      return this.selectedStores.size
    },
  },
  watch: {
    searchZip1: watcherFunc(1),
    searchZip2: watcherFunc(2),
    searchZip3: watcherFunc(3),
    searchZip4: watcherFunc(4),
    searchZip5: watcherFunc(5),
  },
  components: {
    PageHeader,
    ZipSearch,
  },
  beforeMount: loadForm(
    'storefeed',
    'selectedStores1',
    'selectedStores2',
    'selectedStores3',
    'selectedStores4',
    'selectedStores5',
    'searchZip1',
    'searchZip2',
    'searchZip3',
    'searchZip4',
    'searchZip5',
    'searchStores1',
    'searchStores2',
    'searchStores3',
    'searchStores4',
    'searchStores5',
  ),
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints';

.panel-white {
  width: 80%;
  @media (max-width: $bp-md) {
    width: 100%;
  }
}
</style>
